
import React, { useEffect, useState } from "react";
import classnames from "classnames";

// reactstrap components
import {
  UncontrolledAlert,
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  Modal,
  CardBody,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText,
  ModalBody,
  ModalHeader,
  Label,
  Pagination, PaginationItem, PaginationLink,
} from "reactstrap";
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import { getAllProducts, deleteProduct, updateProduct } from "api/productsApiCall";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { useTranslation } from '../../../i18n/context';

function Products() {
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [allProductsError, setAllProductsError] = useState({});
  const [formModal, setFormModal] = React.useState(false);
  const [productName, setProductName] = React.useState(false);
  const [productDescription, setProductDescription] = React.useState(false);
  const [productCategory, setProductCategory] = React.useState(false);
  const [productPrice, setProductPrice] = React.useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [tooltipIds, setTooltipIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (Array.isArray(allProducts)) {
      const ids = allProducts.map((_, index) => ({
        edit: `tooltipEdit${index}`,
        delete: `tooltipDelete${index}`,
      }));
      setTooltipIds(ids);
    } else {
      console.warn('allProducts is not an array:', allProducts);
    }
  }, [allProducts]);

  useEffect(() => {
    const results = allProducts.filter(product =>
      product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredProducts(results);
    setCurrentPage(1);
  }, [searchTerm, allProducts]);


  const toggleModal = () => {
    setFormModal(!formModal);
  };

  const handleEditClick = (productData) => {
    setSelectedProduct(productData);
    toggleModal();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const [errorProductsCall, successUserCall] = await updateProduct(selectedProduct);
      if (errorProductsCall) {
        setErrorMessages(errorProductsCall.message);
        setShowErrorAlert(true);
      } else {
        setShowSuccessAlert(true);
        window.location.reload();
      }
    } catch (error) {
      setErrorMessages([error.message]);
      setShowErrorAlert(true);
    }
  };

  //Delete
  const handleDeleteClick = (productId) => {
    Swal.fire({
      title: t('category.sure'),
      text: t('category.delete_text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: t('category.delete_confirm')
    }).then((result) => {
      if (result.isConfirmed) {
        deleteProduct(productId)
          .then(([error, successData]) => {
            if (error) {
              Swal.fire(
                t('profile.error'),
                error.message || t('product.not_successful'),
                'error'
              );
            } else {
              Swal.fire(
                t('product.delete'),
                t('product.deleted'),
                'success'
              ).then(() => {
                window.location.reload();
              });
            }
          })
          .catch(error => {
            Swal.fire(
              t('profile.error'),
              t('category.delete_error_title'),
              'error'
            );
          });
      }
    });
  };

  useEffect(() => {
    // console.log("allProducts state:", allProducts);
  }, [allProducts]);


  const handleProductsCall = async () => {
    const [errorProductsCall, successProductCall] = await getAllProducts();
    if (errorProductsCall) {
      setAllProductsError(errorProductsCall);
    } else if (successProductCall) {
      setAllProducts(successProductCall);
    } else {
      setAllProductsError({ message: 'No data received from the server' });
    }
  };


  useEffect(() => {
    handleProductsCall();
  }, [])

  useEffect(() => {
    const timeOutError = setTimeout(() => {
      setAllProductsError({});
    }, 10000)
    return () => {
      clearTimeout(timeOutError);
    }
  }, [allProductsError])

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <SimpleHeader name={t('product.products')} parentName={t('product.products')} />
      <Container className="mt--6" fluid>
        <Card>
          <CardHeader className="border-0">
            <Row>
              <Col xs="6">
                <h3 className="mb-0">{t('product.management')}</h3>
              </Col>
              <Col className="text-right" xs="6">
                <Button
                  className="btn-round btn-icon"
                  color="primary"
                  // href="#pablo"
                  id="tooltip443412080"
                  onClick={() => navigate('/admin/addproducts')}
                  size="sm"
                >
                  <span className="btn-inner--icon mr-1">
                    <i className="fas fa-user-edit" />
                  </span>
                  <span className="btn-inner--text">{t('product.add_products')}</span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip443412080">
                  {t('product.add_products')}
                </UncontrolledTooltip>
              </Col>
            </Row>
          </CardHeader>
          <div className="px-3 py-2">
            <Input
              type="text"
              placeholder={t('product.search')}
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>

          {allProducts && allProducts.length > 0 && (

            <Table className="align-items-center table-flush" responsive striped>
              <thead className="thead-light">
                <tr>
                  <th>{t('product.product_name')}</th>
                  <th>Description</th>
                  {/* <th>{t('product.quantity')}</th> */}
                  <th>{t('product.price')}</th>
                  <th>{t('category.cat')}</th>
                  <th>Action</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {currentItems.map((productData, index) => (

                  <tr key={index}>
                    <td>{productData?.product_name}</td>
                    <td>{productData?.description}</td>
                    {/* <td>{productData?.quantity}</td> */}
                    <td>{productData?.currency} {productData?.price}</td>
                    <td>{productData?.category_name}</td>
                    <td className="table-actions">
                      <a
                        className="table-action"
                        href="#pablo"
                        id={tooltipIds[index]?.edit}
                        onClick={(e) => {
                          e.preventDefault();
                          handleEditClick(productData);
                        }}
                      >
                        <i className="fas fa-address-book" />
                      </a>
                      {tooltipIds[index] && (
                        <UncontrolledTooltip delay={0} target={tooltipIds[index].edit}>
                          {t('product.edit')}
                        </UncontrolledTooltip>
                      )}
                      <a
                        className="table-action table-action-delete"
                        href="#pablo"
                        id={tooltipIds[index]?.delete}
                        onClick={(e) => {
                          e.preventDefault();
                          handleDeleteClick(productData._id);
                        }}
                      >
                        <i className="fas fa-trash" />
                      </a>
                      {tooltipIds[index] && (
                        <UncontrolledTooltip delay={0} target={tooltipIds[index].delete}>
                          {t('product.delete')}
                        </UncontrolledTooltip>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          <div className="card-footer py-4">
            <Pagination>
              <PaginationItem disabled={currentPage === 1}>
                <PaginationLink previous onClick={() => paginate(currentPage - 1)} />
              </PaginationItem>
              {[...Array(Math.ceil(filteredProducts.length / itemsPerPage))].map((_, index) => (
                <PaginationItem key={index} active={index + 1 === currentPage}>
                  <PaginationLink onClick={() => paginate(index + 1)}>
                    {index + 1}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem disabled={currentPage === Math.ceil(filteredProducts.length / itemsPerPage)}>
                <PaginationLink next onClick={() => paginate(currentPage + 1)} />
              </PaginationItem>
            </Pagination>
          </div>
        </Card>

      </Container>

      <Modal className="modal-dialog-centered" size="sm" isOpen={formModal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{t('product.edit')}</ModalHeader>
        <ModalBody>
          <Card className="bg-secondary border-0 mb-0">
            <CardBody className="">
              <div className="text-center text-muted mb-4">
                <small>{t('product.edit_details')}</small>
                {showSuccessAlert && (
                  <UncontrolledAlert color="success">
                    <span className="alert-text ml-1">
                      <strong>{t('common.success')}</strong> {t('common.product_updated')}
                    </span>
                  </UncontrolledAlert>
                )}

                {showErrorAlert && (
                  <UncontrolledAlert color="danger">
                    <span className="alert-text ml-1">
                      <strong>{t('profile.error')}</strong>{t('product.failed')}
                    </span>
                  </UncontrolledAlert>
                )}
              </div>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Label
                    className="form-control-label"
                    htmlFor="example-email-input"
                    md="4"
                  >
                    {t('product.products')}
                  </Label>
                  <Col md="8">
                    <FormGroup>
                      <InputGroup className={classnames("input-group-merge", { focused: productName })}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder={t('product.product_name')}
                          type="text"
                          value={selectedProduct.product_name || ''}
                          onChange={(e) => setSelectedProduct({ ...selectedProduct, product_name: e.target.value })}
                          required
                          onFocus={() => setProductName(true)}
                          onBlur={() => setProductName(false)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Label
                    className="form-control-label"
                    htmlFor="example-email-input"
                    md="4"
                  >
                    {t('product.details')}
                  </Label>
                  <Col md="8">
                    <FormGroup>
                      <InputGroup className={classnames("input-group-merge", { focused: productDescription })}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Description"
                          type="text"
                          value={selectedProduct.description || ''}
                          onChange={(e) => setSelectedProduct({ ...selectedProduct, description: e.target.value })}
                          required
                          onFocus={() => setProductDescription(true)}
                          onBlur={() => setProductDescription(false)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Label
                    className="form-control-label"
                    htmlFor="example-email-input"
                    md="4"
                  >
                    {t('category.cat')}
                  </Label>
                  <Col md="8">
                    <FormGroup>
                      <InputGroup className={classnames("input-group-merge", { focused: productCategory })}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder={t('category.cat')}
                          type="text"
                          value={selectedProduct.category_name || ''}
                          onChange={(e) => setSelectedProduct({ ...selectedProduct, category_name: e.target.value })}
                          required
                          onFocus={() => setProductCategory(true)}
                          onBlur={() => setProductCategory(false)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Label
                    className="form-control-label"
                    htmlFor="example-email-input"
                    md="4"
                  >
                    {t('product.price')}
                  </Label>
                  <Col md="8">
                    <FormGroup>
                      <InputGroup className={classnames("input-group-merge", { focused: productPrice })}>
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            {selectedProduct.currency} {/* Default to '$' if currency is not defined */}
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          placeholder="Address"
                          type="text"
                          value={selectedProduct.price || ''}
                          onChange={(e) => setSelectedProduct({ ...selectedProduct, price: e.target.value })}
                          required
                          onFocus={() => setProductPrice(true)}
                          onBlur={() => setProductPrice(false)}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  {/* <Label
                    className="form-control-label"
                    htmlFor="example-email-input"
                    md="4"
                  >
                    Quantity
                  </Label>
                  <Col md="8">
                    <FormGroup>
                      <InputGroup className={classnames("input-group-merge", { focused: productQuantity })}>
                        <Input
                          placeholder="Town"
                          type="text"
                          value={selectedProduct.quantity || ''}
                          onChange={(e) => setSelectedProduct({ ...selectedProduct, quantity: e.target.value })}
                        onFocus={() => setProductQuantity(true)}
                        onBlur={() => setProductQuantity(false)}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>
                            <i className="fas fa-eye" />
                          </InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </FormGroup>
                  </Col> */}
                </Row>
                <Button className="btn-icon" color="primary" type="submit">
                  <span className="btn-inner--text">{t('profile.submit')}</span>
                </Button>
                <Button color="secondary" onClick={toggleModal}>{t('profile.cancel')}</Button>
              </Form>
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Products;
